import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import './index.css'
import { debounce } from 'lodash'
import AccordionItem from '../../molecule/accordionItem/index.tsx'
import BtnPrimary from '../../atom/btn-primary/index.tsx'
import { scrollToSection } from '../../../helpers/index.tsx'

interface Props {
  viewType?: 1 | 2 | 3
}

const InfoContent : React.FC<Props> = ({
	viewType = 1
}) => {
	const { t } = useTranslation('home')
	const { t: tFaq } = useTranslation('faq')
	const scrollRef = useRef(null)

	const [openIndex, setOpenIndex] = useState(null) // Track which item is open

	const handleScroll = debounce(() => {
		const scrollContainer = scrollRef.current
		// @ts-ignore
		const scrollPosition = scrollContainer.scrollLeft
		const itemWidth = 320 // Assuming item width + gap

		// Calculate the nearest item position and snap smoothly
		const snapPosition = Math.round(scrollPosition / itemWidth) * itemWidth
		// @ts-ignore
		scrollContainer.scrollTo({ left: snapPosition, behavior: 'smooth' })
	}, 100) // Adjust debounce timing if necessary (e.g., 100ms)

	const handleClick = (index) => {
		setOpenIndex(openIndex === index ? null : index) // Toggle open/close for each item
	}

	if (viewType === 1) {
		return (
			<section className='info-content-main-container'>
				<img className='info-content-image' src={require('../../../assets/weddingCamera/usecase-image.png')} alt='Prikupljanje uspomena s vjenčanja putem aplikacije Wedding Camera'/>

				<div className='info-content-text-container'>
					<h2 className='info-content-title'>
						{t('info.title')}
					</h2>

					<p className='info-content-text'>
						{t('info.subtitle')}
					</p>
				</div>

			</section>
		)
	}

	if (viewType === 2) {
		const whyChooseUsItems = [1, 2, 3, 4].map(index => ({
			title: t(`whyChooseUs.item${index}.title`),
			text: t(`whyChooseUs.item${index}.text`)
		}))

		return (
			<section className='item-container-main-container why-choose-us-section'>
				<div className='why-choose-us-shell'>
					<div className='why-choose-us-container'>
						<span className='why-choose-us-rule' aria-hidden='true' />
						<h2 className='why-choose-us-title'>{t('whyChooseUs.title')}</h2>
					</div>

					<ul className='why-us-list'>
						{whyChooseUsItems.map((item, index) => (
							<li className='why-us-item' key={index}>
								<span className='why-us-item-accent' aria-hidden='true' />
								<div>
									<h3>{item.title}</h3>
									<p>{item.text}</p>
								</div>
							</li>
						))}
					</ul>
				</div>
			</section>
		)
	}

	if (viewType === 3) {
		const faqItems = tFaq('items', { returnObjects: true }) as {title: string, text: string}[]

		return (
			<section id='faq' className='item-container-main-container faq-main-container'>
				<div className='item-container-text-title-container faq-text-title-container'>
					<h2 className='item-container-title faq-container-title'>{tFaq('title')}</h2>
					<BtnPrimary className='faq-btn-question' title={tFaq('askQuestion')} onPress={() => {
						scrollToSection('contact')
					}} />
				</div>

				<div className="scroll-faq"
					ref={scrollRef}
					onScroll={handleScroll}>
					{Array.isArray(faqItems) && faqItems.map((item, index) => (
						<AccordionItem
							key={index}
							index={index}
							item={item}
							isOpen={openIndex === index}
							onClick={() => handleClick(index)}
						/>
					))}

					<BtnPrimary className='faq-btn-question faq-data-btn' title={tFaq('askQuestion')} onPress={() => {
						scrollToSection('contact')
					}} />
				</div>

			</section>
		)
	}

	return null
}

export default InfoContent
